import React from 'react';
import "../App.css";
const Footer = () => {
  return (

          <footer className="footer">
            <div className="container">
              <p className="text-center">
              Copyright &copy; {new Date().getFullYear()} <b>Vidyarthi-24</b>
              </p>
            </div>
          </footer>
    
      
  );
};

export default Footer;
